import {Box, Grid, Link, Typography} from "@mui/material";
import Facebook from "../../ui/ShareIcons/Facebook";
import Twitter from "../../ui/ShareIcons/X";
import Pinterest from "../../ui/ShareIcons/Pinterest";
import CopyLink from "../../ui/ShareIcons/CopyLink";
import React, {useState} from "react";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import ClientConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import TopNotification from "../TopNotification/TopNotification";

const getShareUrl = (content) =>{
    if(content?.uri_stem){
        return ClientConfigurationHelper.getSiteBaseUrlFromClientConfig(content) + content?.uri_stem;
    }else{
        const typePart = content.entityType === 1 ? "v" : "p";
        return ClientConfigurationHelper.getSiteBaseUrlFromClientConfig(content) + `/${typePart}/${content.titleTextEncoded}/${content.id}`;
    }
}
const ShareActions = ({content}) =>{
    const [openToast, setOpenToast] = useState(false);
    const contentId = content.id;
    const onCopy = () =>{
        setOpenToast(true);
        setTimeout(()=>{
            setOpenToast(false);
        }, 3000)
    }
    return <Box py={2}><Grid container spacing={2}>
        <Grid item xs={4}>
            <Link underline={'none'} color={'inherit'} target="_blank" href={`https://www.facebook.com/sharer/sharer.php?u=${getShareUrl(content)}`} >
                <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
                <Facebook />
                <Typography sx={{pt:1}}>Facebook</Typography>
                </Box>
            </Link>
        </Grid>
        <Grid item xs={4}>
            <Link underline={'none'} color={'inherit'} target="_blank" href={`https://twitter.com/share?url=${getShareUrl(content)}`} >
            <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
            <Twitter width={"86"} />
            <Typography sx={{pt:1}}>X</Typography>
            </Box>
            </Link>
        </Grid>
        <Grid item xs={4}>

            <Link underline={'none'} color={'inherit'} target="_blank" href={`https://pinterest.com/pin/create/button/?url=${getShareUrl(content)}&media=${content?.asset?.thumbnailUrl}&description=${encodeURI(content?.description)}`} >
            <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
                <Pinterest />
                <Typography sx={{pt:1}}>Pinterest</Typography>
            </Box>
            </Link>
        </Grid>
        <Grid item xs={4}>
            <CopyToClipboard text={getShareUrl(content)} onCopy={onCopy}>
            <Box display={'flex'} sx={{cursor: 'pointer'}} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
                <CopyLink />
                <Typography>Copy Link</Typography>
            </Box>
            </CopyToClipboard>
        </Grid>
    </Grid>
        <TopNotification open={openToast} message={"Link copied to clipboard"} />
    </Box>
}
export default ShareActions;